<template>
    <div>
        <full-width-container class="md:hidden">
            <!-- <content-container> -->
            <!--     <div class="mb-2 md:mb-10 lg:hidden" id="dates"> -->
            <!--         <stepper :current_step="current_step"> </stepper> -->
            <!--     </div> -->
            <!-- </content-container> -->
        </full-width-container>
        <find-roatel-bar
            :search="address"
            :properties="allProperties"
            @select="propertySelected($event)"
            @search="getPropertiesByAddress(true)"
            @input="address = $event"
            @geosearch="locate"
            ref="findRoatelBar"
        >
        </find-roatel-bar>
        <app-map
            v-if="properties.length > 0 && $route.params.show === 'map'"
            :properties="properties"
            @property-select="propertySelected($event)"
        >
            MAPS
        </app-map>
        <full-width-container class="bg-r-gray-ultralight">
            <content-container :default-padding="false" class="px-5">
                <div
                    class="flex flex-col w-full"
                    v-if="$route.params.show !== 'map' || !hasProperties"
                >
                    <title-bar v-if="hasProperties">
                        <template v-if="hasGeolocation && location">
                            {{ $t("new_reservation.find_roatel_geo") }}
                        </template>
                        <template v-else-if="location && !hasGeolocation">
                            {{
                                $t("new_reservation.find_roatel_search", {
                                    location: location,
                                })
                            }}
                        </template>
                        <template v-else>
                            {{ $t("new_reservation.find_roatel_all") }}
                        </template>
                    </title-bar>
                    <transition
                        mode="in-out"
                        enter-active-class="transition-all duration-300 ease-in-out"
                        leave-active-class="transition-all duration-300 ease-in-out"
                        enter-class="h-0 opacity-50 transform"
                        enter-to-class="h-auto opacity-100"
                        leave-class="h-auto opacity-100"
                        leave-to-class="h-0 opacity-50 transform"
                    >
                        <alert v-if="geolocationError">
                            <div class="font-medium">
                                {{
                                    $t("new_reservation.geosearch_error.error")
                                }}
                            </div>
                            <div>
                                {{
                                    $t(
                                        "new_reservation.geosearch_error." +
                                            geolocationErrorCodes
                                    )
                                }}
                            </div>
                        </alert>
                    </transition>
                    <transition
                        mode="out-in"
                        enter-active-class="transition-all duration-150 ease-in-out"
                        leave-active-class="transition-all duration-150 ease-in-out"
                        enter-class="opacity-0 scale-75 transform translate-y-48"
                        enter-to-class="opacity-100 scale-100"
                        leave-class="opacity-100 scale-100"
                        leave-to-class="opacity-0 scale-75 transform -translate-y-48"
                    >
                        <div
                            key="results"
                            class="w-full grid grid-cols-1 md:grid-cols-3 gap-5 mb-20"
                            v-if="hasProperties"
                        >
                            <property-card
                                :key="property.uuid"
                                :property="property"
                                @property-select="propertySelected($event)"
                                hoverPointerClass="hover:cursor-pointer"
                                :show-image="true"
                                :show-address="true"
                                :show-open-in-map="true"
                                :show-checkin-until="true"
                                :show-distance="true"
                                :show-book-room-button="true"
                                show-book-room-button-class="lg:hidden"
                                v-for="property in sortedProperties"
                                @property-imprint="
                                    $refs.propertyImprintModal.$refs.modal_imprint.show(
                                        $event
                                    )
                                "
                                :show-room-information-button="true"
                            >
                                <template v-slot:after="{ property }">
                                </template>
                            </property-card>
                        </div>
                        <div
                            key="loading"
                            v-else-if="isSearching"
                            class="md:cutter-big"
                        >
                            <div
                                class="flex flex-col space-y-6 justify-center items-center py-10 px-6 bg-r-black-5 text-r-gray md:p-16 px-5 py-8"
                            >
                                <div>
                                    <font-awesome-icon
                                        icon="spinner"
                                        class="text-4xl text-r-green"
                                        spin
                                    ></font-awesome-icon>
                                </div>
                                <div
                                    class="font-slanted text-center text-r-green italic uppercase text-2xl font-black"
                                >
                                    {{ $t("new_reservation.search_loading") }}
                                </div>
                            </div>
                        </div>
                        <div
                            key="empty"
                            v-else-if="initialized"
                            class="mt-20 mb-20 text-center justify-center bg-white border-r-gray-light rounded-lg grid gap-7 py-8 px-6 lg:py-10 lg:px-32 border"
                        >
                            <div class="flex justify-center">
                                <div
                                    class="w-14 h-14 rounded-full bg-r-gray-ultralight flex justify-center items-center"
                                >
                                    <font-awesome-icon
                                        :icon="
                                            hasGeolocation
                                                ? 'location-crosshairs'
                                                : 'magnifying-glass'
                                        "
                                        class="text-xl text-r-gray"
                                    >
                                    </font-awesome-icon>
                                </div>
                            </div>
                            <div class="grid gap-1">
                                <h2 class="font-bold text-xl">
                                    {{ emptyStateTitle }}
                                </h2>
                                <div class="text-r-gray">
                                    {{ emptyStateBody }}
                                </div>
                            </div>
                            <div class="flex justify-center md:flex-none">
                                <div class="w-full md:w-auto">
                                    <app-button
                                        color="green"
                                        @click="showAllProperties"
                                        >{{
                                            $t(
                                                "new_reservation.search_empty.button_label"
                                            )
                                        }}
                                    </app-button>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
                <property-imprint-modal ref="propertyImprintModal">
                </property-imprint-modal>
            </content-container>
        </full-width-container>
    </div>
</template>

<script>
import ContentContainer from "@guest/common/ContentContainer";
import ClipContainer from "@guest/common/ClipContainer";
import AppInput from "@admin/common/Input";
import AppButton from "@guest/common/Button";
import { mapActions, mapState } from "vuex";
import PropertyCard from "@guest/PropertyCard";
import FindRoatelBar from "@guest/layout/FindRoatelBar";
import TitleBar from "@guest/common/TitleBar";
import FullWidthContainer from "@guest/common/FullWidthContainer.vue";
import Alert from "@guest/common/Alert";
import Stepper from "@guest/bookings/new/Stepper.vue";
import AppMap from "@guest/bookings/new/Map.vue";
import PropertyImprintModal from "@guest/common/PropertyImprintModal.vue";
import { sortProperties } from "@/guest/utils/propertySearch";

export default {
    components: {
        ClipContainer,
        ContentContainer,
        AppButton,
        AppInput,
        PropertyCard,
        FindRoatelBar,
        TitleBar,
        FullWidthContainer,
        Alert,
        Stepper,
        AppMap,
        PropertyImprintModal,
    },
    data: function () {
        return {
            loc: "",
            geolocation: {},
            address: "",
            isLocating: false,
            hasGeolocation: false,
            geolocationError: false,
            geolocationErrorCode: 0,
            hasResults: false,
            searchLocation: null,
            error: "",
            // Number of search requests in flight; drives the loading state.
            pendingRequests: 0,
            // True once a search has finished, so the empty state cannot show
            // before the first request has even started.
            initialized: false,
            // Every bookable Roatel, for the search input's dropdown - the
            // store only holds the current (possibly narrowed) result.
            allProperties: [],
        };
    },
    watch: {
        hasGeolocation: {
            handler: function (value) {
                console.log("hasGeolocation has changed", value);
                if (value === true) {
                    this.getCloseProperties();
                }
            },
        },
    },
    computed: {
        geolocationErrorCodes() {
            let type;
            switch (this.geolocationErrorCode) {
                case 1:
                    type = "PERMISSION_DENIED";
                    break;
                case 2:
                    type = "POSITION_UNAVAILABLE";
                    break;
                case 3:
                    type = "TIMEOUT";
                    break;
                default:
                    type = "POSITION_UNAVAILABLE";
            }
            return type;
        },
        hasProperties() {
            return Array.isArray(this.properties) && this.properties.length > 0;
        },
        // The complete list is ordered like the search input's dropdown;
        // address and geolocation results keep their order by distance.
        sortedProperties() {
            if (!this.hasProperties || this.location || this.hasGeolocation) {
                return this.properties;
            }
            return sortProperties(this.properties);
        },
        isSearching() {
            return this.pendingRequests > 0;
        },
        emptyStateTitle() {
            if (this.hasGeolocation) {
                return this.$t("new_reservation.search_empty.geo_title");
            }
            if (this.location) {
                return this.$t("new_reservation.search_empty.address_title");
            }
            return this.$t("new_reservation.search_empty.all_title");
        },
        emptyStateBody() {
            if (this.hasGeolocation) {
                return this.$t("new_reservation.search_empty.geo_body");
            }
            if (this.location) {
                return this.$t("new_reservation.search_empty.address_body", {
                    location: this.location,
                });
            }
            return this.$t("new_reservation.search_empty.all_body");
        },
        ...mapState({
            properties: (state) => state.search.properties,
            location: (state) => state.search.location,
        }),
    },
    methods: {
        ...mapActions({
            setSearchResult: "setSearchResult",
            resetSearchResult: "resetSearchResult",
            resetBookingDraft: "resetBookingDraft",
        }),
        // Requests are counted so that the loading state survives the handover
        // from locate() to getCloseProperties() (started by the watcher).
        startRequest() {
            this.pendingRequests += 1;
            this.setLoading(true);
        },
        finishRequest() {
            this.pendingRequests = Math.max(0, this.pendingRequests - 1);
            this.initialized = true;
            if (this.pendingRequests === 0) {
                this.setLoading(false);
            }
        },
        showAllProperties() {
            this.address = "";
            this.hasGeolocation = false;
            this.geolocationError = false;
            // The router reuses this component, so mounted() does not run
            // again - the list has to be fetched here.
            if (this.$route.name !== "bookings.new.search_properties") {
                this.$router
                    .push({
                        name: "bookings.new.search_properties",
                        params: { show: "cards" },
                    })
                    .catch(() => {});
            }
            this.getPropertiesByAddress();
        },
        async getPropertiesByAddress(switchToCards = false) {
            this.hasGeolocation = false;
            this.startRequest();
            await axios
                .get(
                    "bookings/get_properties_by_address/" +
                        encodeURIComponent(this.address)
                )
                .then((response) => {
                    this.setSearchResult(response.data);
                    if (this.address === "") {
                        this.allProperties = response.data.data;
                    }
                    //this.$emit('properties-list')
                })
                .catch((error) => {
                    console.log(error);
                })
                .then(() => {
                    this.finishRequest();
                    if (switchToCards && this.$route.params.show === "map") {
                        this.$router.push({ params: { show: "cards" } });
                    }
                });
        },
        // Fills the dropdown when the page was opened with a narrowed search.
        loadAllProperties() {
            if (this.allProperties.length > 0) {
                return;
            }
            axios
                .get("bookings/get_properties_by_address/")
                .then((response) => {
                    this.allProperties = response.data.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        // async getAllProperties() {
        //     this.setSearchResult({ data: [], location: null });
        //     this.setLoading(true);
        //     await axios
        //         .get(
        //             "bookings/close_properties/" +
        //                 this.geolocation.latitude +
        //                 "/" +
        //                 this.geolocation.longitude
        //         )
        //         .then((response) => {
        //             this.setSearchResult(response.data);
        //             //this.$emit('properties-list')
        //         })
        //         .catch((error) => {
        //             console.log(error);
        //         })
        //         .then(() => {
        //             this.setLoading(false);
        //         });
        // },
        async getCloseProperties() {
            this.startRequest();
            await axios
                .get(
                    "bookings/close_properties/" +
                        this.geolocation.latitude +
                        "/" +
                        this.geolocation.longitude
                )
                .then((response) => {
                    this.setSearchResult(response.data);
                    //this.$emit('properties-list')
                })
                .catch((error) => {
                    console.log(error);
                })
                .then(() => {
                    if (this.$route.params.show === "map") {
                        this.$router.push({ params: { show: "cards" } });
                    }
                    this.finishRequest();
                });
        },
        async getLocation() {
            return new Promise((resolve, reject) => {
                if (!("geolocation" in navigator)) {
                    reject(new Error("Geolocation is not available."));
                }
                navigator.geolocation.getCurrentPosition(
                    (pos) => {
                        resolve(pos);
                    },
                    (err) => {
                        reject(err);
                    }
                );
            });
        },
        ...mapActions({
            setLoading: "setLoading",
            setBookingDraftProperty: "setBookingDraftProperty",
        }),
        async locate() {
            this.address = "";
            this.setSearchResult({ data: [], location: null });
            this.startRequest();
            this.geolocationError = false;
            this.geolocationErrorCode = 0;
            this.isLocating = true;
            this.hasGeolocation = false;
            await this.getLocation()
                .then((loc) => {
                    console.log(loc.coords);
                    this.$set(this, "geolocation", {
                        latitude: loc.coords.latitude,
                        longitude: loc.coords.longitude,
                    });
                    this.hasGeolocation = true;
                })
                .catch((error) => {
                    console.log(error);
                    this.hasGeolocation = false;
                    this.geolocationError = true;
                    this.geolocationErrorCode = error.code;
                    this.address = "";
                    this.getPropertiesByAddress();
                })
                .then(() => {
                    this.finishRequest();
                    this.isLocating = false;
                });
        },
        search() {},
        propertySelected(property) {
            this.setBookingDraftProperty(property);
            this.$router.push({ name: "bookings.new.dates" });

            console.log("selected property", property);
        },
    },
    props: {
        current_step: {
            required: true,
            default: 1,
        },
    },
    async mounted() {
        this.resetBookingDraft();
        this.$emit("step", 1);
        // this.locate();
        console.log("route", this.$route);
        if (this.$route.name === "bookings.new.search_properties.geosearch") {
            this.address = this.$route.params.search;
        }
        if (
            this.$route.name === "bookings.new.search_properties.locationsearch"
        ) {
            // locate() falls back to getPropertiesByAddress() when the browser
            // denies the position.
            await this.locate();
        } else {
            await this.getPropertiesByAddress();
        }
        this.loadAllProperties();
        this.$scrollTo("#top");
        console.log("route", this.$route);
    },
};
</script>

<style></style>
